<div class="page-inner main">
    <div class="header-container hide-mobile">
        <h1 translate="PAGES.TITLES.DOWNLOADS"></h1>
    </div>
    <div class="download" *ngFor="let dl of downloads">
        <a [href]="dl.url"><mat-icon inline>picture_as_pdf</mat-icon> {{ dl.title | translate }}</a>
        <p [translate]="dl.description"></p>
    </div>
</div>